import { render, staticRenderFns } from "./PointsExpiration.vue?vue&type=template&id=1fa2af62&"
import script from "./PointsExpiration.vue?vue&type=script&lang=js&"
export * from "./PointsExpiration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports